import script from "./scrollable.vue?vue&type=script&setup=true&lang=js"
export * from "./scrollable.vue?vue&type=script&setup=true&lang=js"

import "./scrollable.vue?vue&type=style&index=0&id=5c55b3ee&scoped=true&lang=sass"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c55b3ee"]])

export default __exports__